/*------------------------------------
 *Author:FortunaTheme
 *Template:Rivo
 *Version:1.1
 *-------------------------------------
 */
export function mainFunctions($, VANTA) {
     /*
         * -----------------------------------------------------------------
         *-------------------------Vanta.js---------------------------------
         * -----------------------------------------------------------------
         */

        if($(".vanta-bg").is(".bird")) {
            VANTA.BIRDS({
                el: "#welcome-vanta-area",
                backgroundColor: 0xc0baa6,
                color1: 0x0,
                color2: 0x0,
                colorMode: "lerp",
                wingSpan: 14.00,
                separation: 59.00,
                cohesion: 17.00,
                quantity: 3.00,
                backgroundAlpha: 0.00
            })

        }
        if($(".vanta-bg").is(".fog")) {
            VANTA.FOG({
                el: "#welcome-vanta-area",
                highlightColor: 0x9ec8e6,
                midtoneColor: 0x979acf,
                baseColor: 0x141414,
                blurFactor: 0.61,
                speed: 2.60
            })
        }

        if($(".vanta-bg").is(".waves")) {
            VANTA.WAVES({
                el: "#welcome-vanta-area",
                color: 0x19303e,
                zoom: 1.22
            })
        }

        if($(".vanta-bg").is(".cloud")) {
            VANTA.CLOUDS({
                el: "#welcome-vanta-area",
                skyColor: 0x1a1d34,
                cloudColor: 0x5e697a,
                cloudShadowColor: 0xb1020
            })
        }

}